<template>
  <!-- 邀请有礼空状态 -->
  <div class="empty">
    <img :src="require('@/images/empty/'+img + '.png')" />
    <div class="text" v-html="desc"></div>
    <div class="bottom">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    desc: String,
    img: {
      type: String,
      default: 'img_none@2x'
    }
  }
}
</script>
<style lang="less" scoped>
.empty {
  height: calc(100% - 112px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 306px;
    height: 306px;
    margin: 0 auto;
  }
  .text {
    font-size: 26px;
    color: @invite-font;
    padding-bottom: 80px;
    text-align: center;
  }
}
</style>
